import { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as licenceVersionServices from '../../services/licenceVersionServices';
import { DeleteModalContext } from "../../layout/BaseLayout";
import moment from "moment";
import { Loader } from "../../utils/loader";
import { getOperators } from "../../services/licenceMasterService";
import { getLicenceAndWhiteLabelList } from "../../services/serviceWatchService";
import { addLicenceAndWhiteLabel, getAllOperatorLicence, getOperatorOfAllLicence } from "../../services/versionMasterServices";

const VersionMasterAddModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

const MapServerModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

const VersionMaster = () => {

   let toast = useContext(ThemeContext);
   let deleteData = useContext(DeleteModalContext);

   const [VersionMasterAddModalShow, setFeedmasterAddModalShow] = useState(false);
   const [deviceTypeError, setDeviceTypeError] = useState(false);
   const [versionNumberError, setVersionNumberError] = useState(false);
   const [whiteLabelIdError, setWhiteLabelIdError] = useState(false);
   const [releaseDateError, setReleseDateError] = useState(false);
   const [operatorIdError, setOperatorIdError] = useState(false);
   const [isEdit, setIsEdit] = useState(false);
   const [loader, setLoader] = useState(false);
   const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
   const [selectedArr, setSelectedArr] = useState([]);
   const [licenceList, setLicenceList] = useState({});
   const [filteredWhiteLabel, setFilteredWhiteLabel] = useState([]);
   const [openMapServer, setOpenMapServer] = useState(false);
   const [companyName, setCompanyName] = useState('');
   const [licenceAndWhiteLabelList, setLicenceAndWhiteLabelList] = useState([]);
   const [filterLicenceAndWhiteLabelList, setFilterLicenceAndWhiteLabelList] = useState([]);
   const [tempSelctedUser, setTempSelctedUser] = useState([]);
   const [tempSelctedRmUser, setTempSelctedRmUser] = useState([]);
   const [selctedUser, setSelctedUser] = useState([]);
   const [selctedUserIds, setSelctedUserIds] = useState([]);
   const [getListOfLicenceForOperator, setGetListOfLicenceForOperator] = useState([]);
   const [operatorIdOnDblClick, setOperatorIdOnDblClick] = useState('');

   const today = moment(new Date().toISOString().slice(0, 16)).format('YYYY-MM-DD');

   const VersionMasterCreationDefaultObj = {
      "operatorId": 'SRK',
      "versionMasterId": 0,
      "versionDeviceType": "",
      "versionNumber": "",
      "versionReleaseDate": today,
      "versionRemarks": "",
      "licenseID": null,
      "IsWhiteLable": false,
      "whiteLabelCode": "",
      "licenseVersionId": null
   }

   const [VersionMasterCreationObj, setVersionMasterCreationObj] = useState({});
   const [selectedLicenceStatus, setSelectedLicenceStatus] = useState("");
   const [groupingLicenceMasterList, setGroupingLicenceMasterList] = useState({});
   const [filterGroupingLicenceMasterList, setFilterGroupingLicenceMasterList] = useState({});
   const [operatorList, setOperatorList] = useState([]);
   const [updatedState, setUpdatedState] = useState([]);

   const getOperatorsLabel = () => {
      getOperators().then((res) => {
         if (res.isSuccess) {
            setOperatorList(!!res && !!res.data && res.data)
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
         }
      })
   }

   const getLicenses = () => {
      setLoader(true);
      licenceVersionServices.getAllLicenceVersion().then((res) => {
         setLoader(false);
         if (res.isSuccess) {
            const groupLicenceMaster = res?.data?.reduce((groups, item) => {
               const opcode = item.operatorId;
               if (!groups[opcode]) {
                  groups[opcode] = [];
               }
               groups[opcode].push(item);
               return groups;
            }, {})
            setGroupingLicenceMasterList(groupLicenceMaster);
            setFilterGroupingLicenceMasterList(groupLicenceMaster);
            setLoader(false);
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
            setLoader(false);
         }
      }).catch(e => {
         setLoader(false);
      })
   }

   const onCreateVersionMaster = () => {
      setDisableSubmitBtn(true);
      let isValid = true;

      if (VersionMasterCreationObj["versionNumber"] === '') {
         setVersionNumberError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (VersionMasterCreationObj['versionDeviceType'] === '') {
         setDeviceTypeError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (VersionMasterCreationObj['versionReleaseDate'] === '') {
         setReleseDateError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }


      if (!!VersionMasterCreationObj['licenseID']) {
         if (VersionMasterCreationObj['whiteLabelCode'] === "" && VersionMasterCreationObj['whiteLabelCode'].length < 3) {
            setWhiteLabelIdError(true);
            setDisableSubmitBtn(false);
            isValid = false;
         }
      }

      const body = {
         "operatorId": !VersionMasterCreationObj['licenseID'] ? VersionMasterCreationObj['operatorId'] : VersionMasterCreationObj['whiteLabelCode'],
         "versionMasterId": VersionMasterCreationObj['versionMasterId'],
         "versionDeviceType": VersionMasterCreationObj['versionDeviceType'],
         "versionNumber": VersionMasterCreationObj['versionNumber'],
         "versionReleaseDate": !!VersionMasterCreationObj['versionReleaseDate'] ? VersionMasterCreationObj['versionReleaseDate'] : today,
         "versionRemarks": VersionMasterCreationObj['versionRemarks'],
         "LicenseID": 1,
         "IsWhiteLable": (!!VersionMasterCreationObj['licenseID'] && !!VersionMasterCreationObj['whiteLabelCode']) ? true : VersionMasterCreationObj['IsWhiteLable'],
         "licenseVersionId": !!VersionMasterCreationObj['licenseVersionId'] ? VersionMasterCreationObj['licenseVersionId'] : 0
      }

      if (isValid) {
         if (!isEdit) {
            licenceVersionServices.addLicenceVersion(body).then((res) => {
               if (res.isSuccess) {
                  let tempVersionMasterData = filterGroupingLicenceMasterList[res.data.operatorId]
                  tempVersionMasterData = [...tempVersionMasterData, res.data];
                  setFilterGroupingLicenceMasterList({
                     ...filterGroupingLicenceMasterList,
                     [res.data.operatorId]: [...tempVersionMasterData],
                  });
                  toast.success(!!res && !!res.successMessage && res.successMessage)
                  setFeedmasterAddModalShow(false);
                  setVersionMasterCreationObj({ ...VersionMasterCreationDefaultObj })
                  setIsEdit(false);
                  setDisableSubmitBtn(false);
               } else {
                  toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
               }
            }).catch(e => {
               setDisableSubmitBtn(false);
            })
         }
         else {
            licenceVersionServices.updateLicenceVersion(body).then((res) => {
               if (res.isSuccess) {
                  let tempVersionMasterData = filterGroupingLicenceMasterList[res.data.operatorId];
                  let index = tempVersionMasterData.map((elem) => { return elem = elem.licenseVersionId }).indexOf(VersionMasterCreationObj.licenseVersionId);
                  tempVersionMasterData[index] = res.data;
                  setFilterGroupingLicenceMasterList({
                     ...filterGroupingLicenceMasterList,
                     [res.data.operatorId]: [...tempVersionMasterData],
                  });
                  toast.success(res.successMessage);
                  setFeedmasterAddModalShow(false);
                  setVersionMasterCreationObj({ ...VersionMasterCreationDefaultObj });
                  setDisableSubmitBtn(false);
               } else {
                  toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
               }
            }).catch(e => {
               setDisableSubmitBtn(false);
            })
         }
      }
   }

   useEffect(() => {
      if (!!selectedLicenceStatus) {
         const filteredLicenceMasterList = Object.keys(groupingLicenceMasterList)
            .filter(key => selectedLicenceStatus.includes(key))
            .reduce((result, key) => {
               result[key] = groupingLicenceMasterList[key];
               return result;
            }, {});
         setFilterGroupingLicenceMasterList(filteredLicenceMasterList);
      } else {
         setFilterGroupingLicenceMasterList({ ...groupingLicenceMasterList });
      }
   }, [selectedLicenceStatus])



   const onDeleteVersionData = (item) => {
      deleteData({ openDeleteModal: true, customMessage: '', callBackFunction: onDeleteVersionDataFn, deleteModalItem: item, isNotValid: null })
   }

   const onDeleteVersionDataFn = (item) => {
      let body = {
         "licenseversionId": item?.licenseVersionId,
         "operatorId": item.operatorId
      }
      let isNotValid = true;
      licenceVersionServices.deleteLicenceVersion(body).then((res) => {
         isNotValid = false;
         if (res.isSuccess) {
            let tempVersionMasterData = filterGroupingLicenceMasterList[item.operatorId]
            let index = tempVersionMasterData.map((elem) => { return elem = elem.licenseVersionId }).indexOf(item.licenseVersionId);
            tempVersionMasterData.splice(index, 1);
            setFilterGroupingLicenceMasterList({
               ...filterGroupingLicenceMasterList,
               [item.operatorId]: [...tempVersionMasterData],
            });
            toast.success(res.successMessage);
            deleteData({ openDeleteModal: false, customMessage: "", callBackFunction: null, deleteModalItem: null, isNotValid: isNotValid })
         } else {
            toast.error(res.exception.message);
            deleteData({ openDeleteModal: true, customMessage: '', callBackFunction: onDeleteVersionDataFn, deleteModalItem: item, isNotValid: isNotValid })
         }
      })
   }

   const editVersionMasterAddModal = (item) => {
      setIsEdit(true);
      setFeedmasterAddModalShow(true);
      setVersionMasterCreationObj({ ...item })
   }

   const getAllLicence = () => {
      getLicenceAndWhiteLabelList().then((res) => {
         if (res.isSuccess) {
            // const filterLic = res?.data?.filter((itm) => itm.licenseStatus)
            setLicenceAndWhiteLabelList(res?.data);
            setFilterLicenceAndWhiteLabelList(res?.data);
            const groupLicenceMaster = res?.data?.reduce((groups, item) => {
               const opcode = item.operatorId;
               if (!groups[opcode]) {
                  groups[opcode] = [];
               }
               groups[opcode].push(item);
               return groups;
            }, {})
            setLicenceList(groupLicenceMaster);
         }
      })
   }

   const onChange = (event) => {
      let name = event.target.name;
      let value = event.target.value;

      if (event.target.name === "operatorId") {
         const licenceItems = licenceList[event.target.value] || [];
         const filteredItems = licenceItems.filter(
            (item) => item.operatorId === event.target.value && item.whiteLabel
         );
         setFilteredWhiteLabel(filteredItems);
      }

      let data = VersionMasterCreationObj;
      data[name] = value;
      setVersionMasterCreationObj({ ...data });
   }

   const openVersionMasterAddModal = () => {
      if (VersionMasterCreationObj["operatorId"] && VersionMasterCreationObj['licenseID']) {
         const licenceItems = licenceList[VersionMasterCreationObj["operatorId"]] || [];
         const filteredItems = licenceItems.filter(
            (item) => item.operatorId === VersionMasterCreationObj["operatorId"] && item.whiteLabel
         );
         setFilteredWhiteLabel(filteredItems);
      } else {
         setFilteredWhiteLabel([]);
      }
      setVersionMasterCreationObj({ ...VersionMasterCreationDefaultObj })
      setFeedmasterAddModalShow(true);
   }

   const closeVersionMasterAddModal = () => {
      setFilteredWhiteLabel([]);
      setVersionMasterCreationObj({ ...VersionMasterCreationDefaultObj })
      setFeedmasterAddModalShow(false);
      setIsEdit(false);
      setDeviceTypeError(false);
      setVersionNumberError(false);
      setReleseDateError(false);
      setDisableSubmitBtn(false);
   }

   const handleSubmitonEnter = (e) => {
      if (e.keyCode === 13) {
         onCreateVersionMaster();
      }
   }

   const onSelectionRow = (item) => {
      if (!!Object.values(filterGroupingLicenceMasterList) && Object.values(filterGroupingLicenceMasterList).length > 0) {
         let tempStoreVersionList = Object.values(filterGroupingLicenceMasterList).flat();
         const selectedRow = tempStoreVersionList.map((elem) => { return elem.licenseVersionId }).indexOf(item.licenseVersionId);
         if (selectedRow > -1) {
            setSelectedArr([tempStoreVersionList[selectedRow]]);
         }
      }
   }

   const checkItem = (item) => {
      const checkData = !!selectedArr && selectedArr.some((val) => val?.licenseVersionId === item?.licenseVersionId);
      return checkData;
   }

   const closeMapServerModal = () => {
      setOpenMapServer(false);
      setTempSelctedUser([]);
      setTempSelctedRmUser([]);
      setSelctedUserIds([]);
   }

   const updateMapServerList = () => {
      let body = {
         "operatorId": operatorIdOnDblClick,
         "LicenseID": selctedUser?.map((itm) => itm.licenseId).join(",")
      }
      addLicenceAndWhiteLabel(body).then((res) => {
         if (res.isSuccess) {
            toast.success(res.successMessage);
            setOpenMapServer(false);
         } else {
            toast.error(res?.exception?.message);
         }
      }).catch(error => {
         console.error(error);
      })
   }

   const addToSelectedList = () => {
      const newUsers = licenceAndWhiteLabelList.filter(item => tempSelctedUser.includes(item.licenseId));
      const updatedUsers = [...selctedUser, ...newUsers];

      setSelctedUser(updatedUsers);
      setSelctedUserIds(updatedUsers.map(user => user.licenseId));
      setTempSelctedUser([]);
      setTempSelctedRmUser([]);
      const filtredData = licenceAndWhiteLabelList.filter(item => !tempSelctedUser.includes(item.licenseId));
      setLicenceAndWhiteLabelList([...filtredData]);
   }

   const removeToSelectedList = () => {
      const updatedUsers = selctedUser.filter(item => !tempSelctedRmUser.includes(item.licenseId));
      const removedUsers = selctedUser.filter(item => tempSelctedRmUser.includes(item.licenseId));
      const updatedIds = updatedUsers.map(user => user.licenseId);
      setLicenceAndWhiteLabelList([...removedUsers, ...licenceAndWhiteLabelList]);

      setTempSelctedUser([]);
      setTempSelctedRmUser([]);
      setSelctedUser(updatedUsers);
      setSelctedUserIds(updatedIds);
   }


   const getAllLicenceForOperator = (itm) => {
      getOperatorOfAllLicence(itm?.operatorId).then((res) => {
         if (res.isSuccess) {
            setOpenMapServer(true);
            setCompanyName(itm?.companyName);
            setOperatorIdOnDblClick(itm?.operatorId);
            setGetListOfLicenceForOperator(res?.data?.licenseDetail);
            const selectedLicenseIds = res?.data?.licenseDetail?.map((license) => license.licenseId);
            const availableLicenses = filterLicenceAndWhiteLabelList.filter(
               (item) => !selectedLicenseIds.includes(item.licenseId));
            setSelctedUser(res?.data?.licenseDetail);
            setLicenceAndWhiteLabelList(availableLicenses);
         }
      })
   }

   useEffect(() => {
      getLicenses();
      getOperatorsLabel();
      getAllLicence();
   }, [])

   return (
      <>
         <div id="tabs">
            {loader && <Loader />}
            <div className="maintitle-box">
               <div className="w-75 d-inline-block">
                  <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/version-icon.svg"} alt="" />Version Master</h2>
               </div>
               <div className="align-center d-flex d-inline-block justify-content-end w-50">
                  <div className="d-inline-block mr-3"><i id="moduleMasterRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
                     onClick={() => { getLicenses(); getOperatorsLabel(); setSelectedLicenceStatus(""); }}></i>
                  </div>
                  <div className="d-inline-block float-end w-200 mr-2">
                     <select className="form-select inputborder w-100 font11" value={selectedLicenceStatus} onChange={(e) => { setSelectedLicenceStatus(e.target.value) }}>
                        <option value="">All</option>
                        {Object.entries(groupingLicenceMasterList).sort().map(([key, item]) => {
                           return (
                              <option key={key} value={key}>{key}</option>
                           )
                        })}
                     </select>
                  </div>
                  <div className="float-end ">
                     <button className="addnewbtn mb-0" onClick={() => { openVersionMasterAddModal() }}>
                        <i className="fa-solid fa-circle-plus mr-2"></i>Add
                     </button>
                  </div>
               </div>
            </div>
            {Object.keys(filterGroupingLicenceMasterList).length > 0 ? Object.entries(filterGroupingLicenceMasterList).map(([opercode, groups]) => ({ opercode, groups })).sort((a, b) => a.opercode.localeCompare(b.opercode)).map(({ opercode, groups }) => {
               const operatorDetails = operatorList.filter(itm => itm.operatorId === opercode);
               return (
                  <>
                     <div className="thead-fixed" key={opercode}>
                        <div className='font-13 font-bold ml-2'>{`${opercode} ${!!operatorDetails[0]?.companyName ? ' - ' + operatorDetails[0]?.companyName : ''}`} <button className="server-mapping-btn ml-3 mb-1" onClick={() => { getAllLicenceForOperator(operatorDetails[0]) }}>Server Mapping</button></div>
                        <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                           <thead>
                              <tr className="thead-dard-bg">
                                 <th className="srn-width">Sr</th>
                                 <th className={`feed-m-name`}>Device Type</th>
                                 <th className={`lic-domain`}>Version Number</th>
                                 <th className={`feed-m-name`}>Release Date </th>
                                 <th className={``}>Remarks</th>
                                 <th className="">Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              {!!groups && groups.map((item, i) => {
                                 let versionTimeZoneDate = !!item?.versionReleaseDate ? moment(new Date(item.versionReleaseDate + "+00:00").toLocaleString('sv-SE')).format('DD/MM/YYYY') : "";
                                 return (
                                    <tr key={"versionMasterList" + i} onDoubleClick={() => { editVersionMasterAddModal(item) }} onClick={() => onSelectionRow(item)} className={`${checkItem(item) ? 'selected-tr' : ''}`}>
                                       <td className="">{i + 1}</td>
                                       <td className="">{item.versionDeviceType}</td>
                                       <td className="">{item.versionNumber}</td>
                                       <td className="">{versionTimeZoneDate}</td>
                                       <td className="">{item.versionRemarks}</td>
                                       <td className=""><i className="fa fa-trash font-size-16 text-danger ml-2" onClick={() => onDeleteVersionData(item)}></i></td>
                                    </tr>
                                 )
                              })}
                           </tbody>
                        </table>
                     </div>
                  </>)
            }
            ) : <></>}
         </div>
         <div className="login-popup">
            <Modal
               className="datafeed trade"
               show={openMapServer}
               onHide={() => closeMapServerModal()}
               backdrop="static"
               dialogAs={MapServerModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     Server Mapping
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                     <div className="dealer-listiong-box">
                        <div className="mapModule-height">
                           <table border="0" cellSpacing="0" cellPadding="0" className="w-100 whitespace">
                              <tbody>
                                 <tr>
                                    <div className="d-flex">
                                       Company Name: <span className="font-bold">{companyName}</span>
                                    <div className="ml-4 font-bold colorcode">
                                    <span className="whiteLabelInfoColor mr-1"></span>
                                    <span className="mr-1">WhiteLabel</span>
                                    </div>
                                    <div className="ml-2 font-bold colorcode">
                                    <span className="disableInfoColor mr-1"></span>
                                    <span className="mr-1">Disable Licence</span>
                                    </div>
                                    <div className="ml-2 font-bold colorcode">
                                    <span className="selectedInfoColor mr-1"></span>
                                    <span className="mr-1">Selected</span>
                                    </div>
                                    </div>
                                 </tr>
                                 <div className='mt-2'>
                                    {<>
                                       <div className='dlb-width-group-1 '>&nbsp;</div>
                                       <div className='dlb-width-group-30'>
                                          <div className='font11'>Licence & Whitelabel:</div>
                                          <div className='br-main1'>
                                             <div>
                                                <table className="table table-bordered table-strip w-100 mb-0 mt-0">
                                                   <thead>
                                                      <tr className="thead-dard-bg">
                                                         <td>Name</td>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {!!licenceAndWhiteLabelList && licenceAndWhiteLabelList?.length > 0 && licenceAndWhiteLabelList?.map((item, index) => {
                                                         // if (selctedUserIds.indexOf(item.licenseId) > -1) {
                                                         //    return false
                                                         // }
                                                         return (
                                                            <tr key={index}
                                                               onClick={() => {
                                                                  // toggleSelection(item.licenseId)
                                                                  let listData = tempSelctedUser
                                                                  if (listData.indexOf(item.licenseId) > -1) {
                                                                     listData.splice(listData.indexOf(item.licenseId), 1)
                                                                  } else {
                                                                     listData.push(item.licenseId)
                                                                  }
                                                                  setTempSelctedUser([...listData]);
                                                               }}
                                                               // disabled={!item?.licenseStatus}
                                                               className={tempSelctedUser.indexOf(item.licenseId) > -1 ? "selected-tr" : !item?.licenseStatus && 'text-pink'}
                                                               style={!item?.licenseStatus ? { pointerEvents: 'none', opacity: 0.8 } : {}}
                                                            >
                                                               <td className={`${item?.whiteLabel ? 'licence-bg-red' : ""}`} >{item?.serverDisplayName}</td>
                                                            </tr>
                                                         )
                                                      })}
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                       </div>
                                       <div className='dlb-width-group-1 '>&nbsp;</div>
                                       <div className='dlb-width-group-10'>
                                          <div className="font11">Action</div>
                                          <div className='br-main1'>
                                             <div className='cg-flex-center'>
                                                <div className='d-flex'>
                                                   <button type="button" className="btn btn-primary btnmain mb-2" onClick={() => addToSelectedList()} ><i className="fa fa-angle-double-right" aria-hidden="true"></i></button>
                                                </div>
                                                <button type="button" className="btnmain-danger btn btn-primary" onClick={() => removeToSelectedList()}><i className="fa fa-angle-double-left" aria-hidden="true"></i></button>
                                             </div>
                                          </div>
                                       </div>
                                       <div className='dlb-width-group-1'>&nbsp;</div>
                                       <div className='dlb-width-group-30'>
                                          <div className='font11'>Selected Licence & Whitelabel:</div>
                                          <div className='br-main1'>
                                             <table className="table table-bordered table-strip w-100 mb-0 mt-0">
                                                <thead>
                                                   <tr className="thead-dard-bg">
                                                      <td className="">Name </td>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {!!selctedUser && selctedUser?.length > 0 && selctedUser?.map((itm, index) => {
                                                      return (
                                                         <tr
                                                            onClick={() => {
                                                               let listData = tempSelctedRmUser
                                                               if (listData.indexOf(itm.licenseId) > -1) {
                                                                  listData.splice(listData.indexOf(itm.licenseId), 1)
                                                               } else {
                                                                  listData.push(itm.licenseId)
                                                               }
                                                               setTempSelctedRmUser([...listData])
                                                            }}
                                                            key={`acclstnew_${itm.licenseId}`} className={tempSelctedRmUser.indexOf(itm.licenseId) > -1 ? "selected-tr" : !itm?.licenseStatus && 'text-pink'}>
                                                            <td key={index} className={`${itm?.whiteLabel ? 'licence-bg-red' : ""}`}>{itm?.serverDisplayName}</td>
                                                         </tr>
                                                      );
                                                   })
                                                   }
                                                </tbody>
                                             </table>
                                          </div>
                                       </div>
                                    </>}
                                 </div>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        <Button className="btnmain mr-3" onClick={() => { updateMapServerList() }}>
                           Submit
                        </Button>
                        <Button onClick={() => closeMapServerModal()} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
         <div className="login-popup">
            <Modal
               className="datafeed modal show"
               show={VersionMasterAddModalShow}
               onHide={() => closeVersionMasterAddModal()}
               backdrop="static"
               dialogAs={VersionMasterAddModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     Version Master
                     <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                     <div className="feederbox">
                        <div className="fidderbox-inner office-height">
                           <table border="0" cellSpacing="0" cellPadding="0" className="w-100 whitespace">
                              <tbody>
                                 <tr>
                                    <td className="w-25 font11 text-right font11 v-align-baseline">Operator Id:</td>
                                    <td className="feederw-430 loginUser ">
                                       <select className={`form-select inputborder w-100 font11 mb-2 ml-2 h20`} name='operatorId' value={VersionMasterCreationObj['operatorId']} onChange={(e) => { onChange(e) }} disabled={isEdit}>
                                          {operatorList.map((item) => {
                                             return (
                                                <option key={item.operatorId} value={item.operatorId}>{item.operatorId} - {item.companyName}</option>
                                             )
                                          })}
                                       </select>
                                    </td>
                                 </tr>
                                 {
                                    <tr>
                                       <td className="w-25 font11 text-right font11 v-align-baseline">White Label:</td>
                                       <td className="feederw-430 loginUser ">
                                          <select className={`form-select inputborder w-100 font11 mb-2 ml-2 h20`} name='licenseID' value={VersionMasterCreationObj['licenseID']} onChange={(e) => { onChange(e); (e.target.value === "" && setFilteredWhiteLabel([])) }}>
                                             <option value="">Select</option>
                                             {filteredWhiteLabel.map((item) => {
                                                return (
                                                   <option key={item.licenseId} value={item.licenseId}>{item.serverDisplayName}</option>
                                                )
                                             })}
                                          </select>
                                       </td>
                                    </tr>}
                                 {!!filteredWhiteLabel && filteredWhiteLabel?.length > 0 && !!VersionMasterCreationObj['licenseID'] &&
                                    <tr>
                                       <td className="w-25 font11 text-right font11 v-align-baseline">White Label ID:</td>
                                       <td className={`feederw-430 text-right false ${whiteLabelIdError && 'error'}`}>
                                          <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" name="whiteLabelCode" value={VersionMasterCreationObj['whiteLabelCode'].toUpperCase()} onChange={(e) => {
                                             onChange(e);
                                             (!!VersionMasterCreationObj['licenseID'] && (e.target.value === '' || e.target.value.length < 3) ? setWhiteLabelIdError(true) : setWhiteLabelIdError(false))
                                          }}
                                             maxLength={3}
                                             onKeyDown={(e) => handleSubmitonEnter(e)} /> </td>
                                       <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                    </tr>
                                 }
                                 <tr>
                                    <td className="w-25 font11 text-right font11 v-align-baseline">Device Type:</td>
                                    <td className="feederw-430 loginUser ">
                                       <select className={`form-select inputborder w-100 font11 mb-2 ml-2 h20 ${deviceTypeError && 'error'} `} name='versionDeviceType' autoFocus value={VersionMasterCreationObj['versionDeviceType']}
                                          onChange={(e) => {
                                             onChange(e); (e.target.value === '' ? setDeviceTypeError(true) : setDeviceTypeError(false))
                                          }}
                                          onKeyDown={(e) => handleSubmitonEnter(e)}
                                          disabled={isEdit}
                                       >
                                          <option value=''>Select Device Type</option>
                                          <option value='ANDROID'>Android</option>
                                          <option value='IOS'>iOS</option>
                                          <option value='ADMIN'>Admin</option>
                                          <option value='DEALER'>Dealer</option>
                                          <option value='CLIENTWEB'>Client Web</option>
                                          <option value='CLIENTMOBAPP'>Client Mobile App</option>
                                          <option value='DEALERTDESKAPP'>Dealer Desktop App</option>
                                          <option value='CLIENTDESKAPP'>Client Desktop App</option>
                                       </select>
                                    </td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="w-25 font11 text-right font11 v-align-baseline">Version Number:</td>
                                    <td className={`feederw-430 text-right false ${versionNumberError && 'error'}`}>
                                       <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" maxLength="50" name="versionNumber" value={VersionMasterCreationObj['versionNumber']} onChange={(e) => {
                                          onChange(e);
                                          (e.target.value === '' ? setVersionNumberError(true) : setVersionNumberError(false))
                                       }}
                                          onKeyDown={(e) => handleSubmitonEnter(e)} /> </td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="w-25 font11 text-right font11 v-align-baseline">Release Date:</td>
                                    <td className={`feederw-430 ${releaseDateError && 'error'}`}>
                                       <input type="date" className="inputborder font11 w-100  ml-2 h20 mb-2" name="versionReleaseDate" value={moment(VersionMasterCreationObj['versionReleaseDate']).format('YYYY-MM-DD')} onChange={(e) => {
                                          onChange(e);
                                          (e.target.value === '' ? setReleseDateError(true) : setReleseDateError(false))
                                       }} onKeyDown={(e) => handleSubmitonEnter(e)} /></td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="w-25 font11 text-right font11 v-align-baseline">Remarks:</td>
                                    <td className="feederw-430 text-right false">
                                       <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" maxLength="50" name="versionRemarks" value={VersionMasterCreationObj['versionRemarks']} onChange={(e) => { onChange(e) }} onKeyDown={(e) => handleSubmitonEnter(e)} /> </td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        <Button className="btnmain mr-3" onClick={() => { onCreateVersionMaster() }}>
                           {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>} Submit
                        </Button>
                        <Button onClick={() => closeVersionMasterAddModal()} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
      </>
   )
}

export default VersionMaster;